import http from './http';

// Регистрация нового пользователя
export const registerUser = async (email, password, telegram_username) => {
  const response = await http.post('/api/auth/register', { email, password, telegram_username });
  return response.data;
};

// Вход существующего пользователя
export const loginUser = async (email, password) => {
  const response = await http.post('/api/auth/login', { email, password });
  return response.data;
};
